<template>
    <div><span v-if="slug" :class="{
        badge: true,
        [`badge-request-bank-decision-${slug}`]: true,
    }">{{status_text}}</span></div>
</template>

<script>
    export default {
        name: "RequestBankDecisionBadge",
        props: ['slug'],
        computed: {
            status_text: function () {
                if (!this.slug) return "";
                switch (this.slug) {
                    case 'approved': return 'Одобрен';
                    case 'rejection': return 'Отказ';
                    case 'limit': return 'Лимит';
                }
            },
        },
    }
</script>

<style scoped>

</style>
